// oxlint-disable-next-line no-restricted-imports
import { RequiredAsterisk } from '@launchpad-ui/core';

const RequiredFieldsNotice = ({ singular = false }: { singular?: boolean }) => (
  <span className="u-fs-sm">
    <RequiredAsterisk /> Required field{singular ? '' : 's'}
  </span>
);

/* eslint-disable import/no-default-export */
export default RequiredFieldsNotice;
